import { render, staticRenderFns } from "./StatisticCardHorizontalDefault.vue?vue&type=template&id=464976d5&"
import script from "./StatisticCardHorizontalDefault.vue?vue&type=script&lang=js&"
export * from "./StatisticCardHorizontalDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports